import React from 'react'
import { HashRouter as Router, Route, Routes } from 'react-router-dom'
import ProtectedRoute from './ProtectedRoute'
import Kode from './tools/Kode'
import NotFound from './utils/NotFound'

export default function RouterPage() {
  return (
    <Router>
        <Routes>
            {/* <Route
              path='/'
              element={
                <ProtectedRoute>
                  <Kode />
                </ProtectedRoute>
              }
            /> */}

            <Route path='/' element={<Kode/>} />
            <Route path='*' element={<NotFound/>} />
        </Routes>
     </Router>
  )
}